import React from 'react';
import { useProducts } from '../../context/ProductsContext';
import { ProductCard } from '../common/ProductCard';
import { Product } from '../../types/store';
import { Sparkles, Gift, CheckCircle2 } from 'lucide-react';

interface BundleDealsSectionProps {
  onSelectProduct: (product: Product) => void;
}

export const BundleDealsSection: React.FC<BundleDealsSectionProps> = ({ onSelectProduct }) => {
  const { products } = useProducts();
  const bundleProducts = products.filter((p) => p.isBundle);

  return (
    <section id="bundle-deals-section" className="py-12 sm:py-16 bg-[#F8FAFC] border-y border-[#E2E8F0]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-10 sm:mb-12">
          <div className="inline-flex items-center gap-1.5 bg-rose-100 text-rose-800 text-[11px] font-black px-3 py-1 rounded-full uppercase tracking-wider mb-2">
            <Gift className="w-3.5 h-3.5 text-rose-600" />
            <span>Value Bundles & Special Offers</span>
          </div>
          <h2 className="text-2xl sm:text-3xl font-extrabold text-[#172554] tracking-tight">
            Buy More Save More
          </h2>
          <p className="text-xs sm:text-sm text-[#64748B] mt-2">
            Stock up on your monthly nutritional goals with our exclusive multi-tin packages and save up to 25% with Free Shipping nationwide.
          </p>
        </div>

        {/* Bundles Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 max-w-4xl mx-auto">
          {bundleProducts.map((bundle) => (
            <div key={bundle.id} className="relative group">
              <ProductCard product={bundle} onSelectProduct={onSelectProduct} />
            </div>
          ))}
        </div>

        {/* Trust Highlight Box */}
        <div className="mt-10 bg-white rounded-2xl p-4 sm:p-6 border border-slate-200 shadow-xs max-w-4xl mx-auto flex flex-wrap items-center justify-around gap-4 text-xs font-semibold text-[#172554]">
          <div className="flex items-center gap-2">
            <CheckCircle2 className="w-4 h-4 text-emerald-600" />
            <span>Mix and match any flavors on delivery</span>
          </div>
          <div className="flex items-center gap-2">
            <CheckCircle2 className="w-4 h-4 text-emerald-600" />
            <span>Free Express Delivery on all bundles</span>
          </div>
          <div className="flex items-center gap-2">
            <CheckCircle2 className="w-4 h-4 text-emerald-600" />
            <span>Cash on Delivery (Pay at Doorstep)</span>
          </div>
        </div>

      </div>
    </section>
  );
};
